import axios from '@axios'

export const state = {
  ownerships: [],
}

export const getters = {
  allOwnerships: (state) => state.ownerships,
}

export const mutations = {
  GET_OWNERSHIPS: (state, resp) => {
    if (!resp) return null
    state.ownerships = resp.ownerships
  },
}

export const actions = {
  async getOwnership({ commit }, params = {}) {
    await axios
      .get('/api/ownerships', { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_OWNERSHIPS', resp.data)
        }
      })
      .catch((err) => {
        commit(
          'GET_OWNERSHIPS',
          err.response.status === 404 ? { ownerships: [] } : null
        )
      })
  },
  async createOwnership({ commit, dispatch }, payload) {
    return axios.post(`/api/cars/${payload.carId}/ownership`, payload.user)
  },
}
